module.exports = __webpack_public_path__ + "media/images/logo-normas-ak-alt-6eab51b9bb8d61cac96c142bd6622e32.png";